<template>
  <v-card class="card-border">
    <highcharts :options="chartOptions" />
  </v-card>
</template>

<script>
import { Chart } from "highcharts-vue";
import { mapGetters } from "vuex";

export default {
  name: "FormasPagamentoLeads",

  components: {
    highcharts: Chart
  },

  data() {
    return {
      chartOptions: {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: "pie",
          events: {
            load(event) {
              this.showLoading("Preencha os campos acima corretamente");
            },

            redraw(event) {
              this.hideLoading();
            }
          }
        },
        title: {
          text: "Percentual de Leads por Formas de Pagamento"
        },
        tooltip: {
          pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>"
        },
        accessibility: {
          point: {
            valueSuffix: "%"
          }
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            dataLabels: {
              enabled: true,
              format: "<b>{point.name}</b>: {point.percentage:.1f} %"
            }
          }
        },
        series: [
          {
            name: "Total",
            colorByPoint: true,
            data: [
              {
                name: "AVista",
                y: 0
              },
              {
                name: "CDC",
                y: 0
              },
              {
                name: "Consorcio",
                y: 0
              }
            ]
          }
        ],
        colors: ["#88D956", "#2CB2AD", "#EFC13B"]
      }
    };
  },

  computed: {
    ...mapGetters("dashboard", ["getLeads"])
  },

  methods: {
    clearChart() {
      this.chartOptions.series[0].data.forEach(data => (data.y = 0));
    },

    generateGrafic(leads) {
      for (const lead of leads) {
        this.chartOptions.series[0].data.forEach(data => {
          data.y += 1 ? data.name === lead.formaDePagamento : null;
        });
      }
    }
  },

  watch: {
    getLeads(leads) {
      this.clearChart();
      this.generateGrafic(leads);
    }
  },

  mounted() {
    if (this.getLeads.length !== 0) {
      this.clearChart();
      this.generateGrafic(this.getLeads);
    }
  }
};
</script>
